import React, { FC, useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useWarehouseAndTenant } from 'hooks/useWarehouseAndTenant'
import {
  BookingWorkRecordHeader,
  BookingWorkRecordEntry,
  BookingWorkRecordEntryFinish,
  BookingWorkRecordTelInput,
  ErrorModal,
} from './components'
import { useBookingWorkRecordStep, STEP } from './hooks/useBookingWorkRecordStep'
import { useBookingWorkRecord } from './hooks/useBookingWorkRecord'
import styles from './style.module.css'

const BookingWorkRecord: FC = () => {
  const history = useHistory()
  const { warehouseId, tenantId } = useParams<{ warehouseId: string; tenantId: string }>()
  const { currentStep, goToEntry, goToTelInput, goToFinish } = useBookingWorkRecordStep()
  const { warehouse, tenant, loading } = useWarehouseAndTenant(warehouseId, tenantId)
  const { workRecordResult, submitBookingWorkRecord, isSubmitError, clearSubmitError, errorMessage } =
    useBookingWorkRecord(tenantId)

  const handleSubmitPhoneNumber = useCallback(
    async (phone: string) => {
      await submitBookingWorkRecord(phone, {
        onSuccess: () => {
          goToFinish()
        },
      })
    },
    [submitBookingWorkRecord, goToFinish]
  )

  if (!loading && tenant && !tenant.canDriverRecordWorkLogOnReception) {
    history.push('/not_found')
    return null
  }

  return (
    <>
      <div className={styles.wrapper}>
        <BookingWorkRecordHeader
          warehouseName={warehouse?.name || ''}
          tenantName={tenant?.name || ''}
        />
        <div className={styles.content}>
          {currentStep === STEP.ENTRY && <BookingWorkRecordEntry onClick={goToTelInput} />}

          {currentStep === STEP.TEL && (
            <BookingWorkRecordTelInput
              isOpen={true}
              onSubmit={handleSubmitPhoneNumber}
              onClose={goToEntry}
            />
          )}

          {currentStep === STEP.FINISH && workRecordResult && (
            <BookingWorkRecordEntryFinish
              status={workRecordResult.status}
              hyphenatedBookingNumber={workRecordResult.hyphenatedBookingNumber}
              finishedAt={workRecordResult.finishedAt}
              onBackButtonClick={goToEntry}
            />
          )}
        </div>
      </div>
      <ErrorModal
        isOpen={isSubmitError}
        message={errorMessage}
        onClose={clearSubmitError}
      />
    </>
  )
}

export default BookingWorkRecord
